import { Box, BoxProps } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import './SVGComponent.css';

interface SVGComponentProps extends BoxProps {
  url: string;
}

export const SVGComponent = ({ url, ...props }: SVGComponentProps) => {
  const [svgContent, setSvgContent] = useState<string>();

  useEffect(() => {
    void fetch(url)
      .then((response) => response.text())
      .then((text) => setSvgContent(text));
  }, [url]);

  return svgContent ? (
    <Box
      className="svg-component"
      dangerouslySetInnerHTML={{ __html: svgContent }}
      {...props}
    />
  ) : null;
};
